import { render, staticRenderFns } from "./PageManualPhotovoltaic.vue?vue&type=template&id=ab1a8a44&scoped=true&"
import script from "./PageManualPhotovoltaic.vue?vue&type=script&lang=js&"
export * from "./PageManualPhotovoltaic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1a8a44",
  null
  
)

export default component.exports